import { createAction } from '@reduxjs/toolkit';
import { Asset } from '../../api';

export const setModal = createAction<{ open: true; assetId: Asset['id'] } | { open: false }>(
  'preview/setModal',
);

export const removeRequested = createAction<{ assetId: Asset['id'] }>('preview/removeRequested');

export const uploadRequested = createAction<{ assetId: Asset['id']; file: File }>(
  'preview/uploadRequested',
);

export const setInProgress = createAction<{ assetId: Asset['id']; inProgress: boolean }>(
  'preview/setInProgress',
);
